import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { useAppUser, useLanguage } from '~/components/molecules';
import { GET_TABLE_METADATA } from '~/gql';

export const useColumnHeading = (name: string, memberName: string) => {
  const appUser = useAppUser();
  const { isAlternateLanguageUsed } = useLanguage();
  const { data, loading, error } = useQuery(GET_TABLE_METADATA, {
    variables: { projectId: appUser?.userAccount?.defaultProject?.id, name },
    fetchPolicy: 'cache-first',
  });

  const columnHeading = useMemo(() => {
    if (!data || loading || error) return null;

    const metadataCol = data.tableMetadata.metadataColumns.find(
      (item: { memberName: string }) => item.memberName === memberName
    );

    if (metadataCol) {
      return isAlternateLanguageUsed ? metadataCol.alternateColumnHeading : metadataCol.columnHeading;
    }

    return null;
  }, [data, loading, error, memberName, isAlternateLanguageUsed]);

  return columnHeading ? columnHeading.replace(/;/g, '\n') : null;
};
